angular.module("datiPersonaFisica.components",[])
.component("datiPersonaFisica",{
    templateUrl: "ng/components/riepilogoEControllo/datiPersonaFisica/datiPersonaFisica.view.html",
    bindings:{
        model:'<',
        verifica:'=',
        readOnly:'<',
        aziendeGaranti:'<'
    },
    controller: DatiPersonaFisica,
    controllerAs: 'datiPFCtrl'
})

function DatiPersonaFisica(
    $configService
){
    var self = this;

    self.$onInit = function(){

        
        
    }

    self.check = function(el){
        el.selected =!el.selected;
        if(el.selected){
            el.ndg= $configService.getUser().ndg;
            el.identifier= $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        }else{
            el.ndg= "";
            el.identifier= "";
            el.dataConferma = "";
        }
    }

}